module.exports = __webpack_public_path__ + "media/images/new/public_land_map_overlays-ebd3d1c7fe9acdb35e2acd7b0400739c.jpg";